import { useAuth } from "../contexts/auth.context";

import React from "react";
import { Navigate, Outlet } from "react-router-dom";

const ProtectedRoutes: React.FC = () => {
    const { user } = useAuth();

    return user.id !== -1 ? <Outlet /> : <Navigate to="/signin" replace />;
};

export default ProtectedRoutes;
